import React, {useRef, useState} from 'react'

import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import PopoverMenu from "../../popover-menu/popover-menu/popover-menu"

type Props = {
    className?          : string

    button              : (isSelected: boolean, onClick: callback) => React.ReactNode
    options             : Option[]

    onTogglePopover?    : callback
}

// Button with a popover menu. The popover anchors to the button itself (the wrapper's first child), not the
// wrapper - the wrapper may be wider (margins, stretching) and the popover arrow aims at the anchor center
export default function PopoverSelectorNew(props: Props) {

    const refSelf                       = useRef<HTMLDivElement>(null)
    const [showPopover, setShowPopover] = useState(false)

    const setPopoverShown = (e: any, value: boolean) => {
        // Popover's Escape handler passes a plain {} as the event
        e?.stopPropagation?.()

        setShowPopover(value)

        return props.onTogglePopover?.(value)
    }

    const hidePopover = (e?: any) => {
        return setPopoverShown(e, false)
    }

    const togglePopover = (e: React.SyntheticEvent) => {
        return setPopoverShown(e, !showPopover)
    }

    const getTarget = () => {
        return refSelf.current?.firstElementChild
    }

    return (
        <div ref        = {refSelf}
             className  = {props.className}
        >
            {props.button(showPopover, togglePopover)}

            {showPopover &&
                <Popover
                    className               = "min-w-250"
                    position                = {PopoverPosition.bottomCenter()}
                    getTargetFunc           = {getTarget}
                    outsideClickIgnoreClass = "option"
                    onClickOutside          = {hidePopover}
                >
                    <PopoverMenu
                        options     = {props.options}
                        hidePopover = {hidePopover}
                    />
                </Popover>
            }
        </div>
    )
}
